import $ from 'jquery';
import mustache from 'mustache';
import Velocity from 'velocity-animate';
import Tooltip from 'tooltip.js';
import SitecoreGoals from './../01-helpers/sitecore-goals';

const selectors = {
	golfClubFinderListTemplate: '#courseFinderListTemplate',
	submitButton: 'button[type="submit"]',
	addressSearchField: 'input[name="Address"]',
	clubsOrCoursesField: 'input[name="ClubsCourses"]',
	resultDiv: '.js-coursefinder__result',
	loadmoreButton: '.js-coursefinder__loadmore',
	golftooltip: '.js-golftooltip',
	sitecoregoals: '.js-sitecoregoals',
	form: '#findcourse'
};

var url = $(selectors.form).data('action'),
	xhrList = [],
	xhr = null,
	initialSize = $(selectors.form).data('initialresults');
class GolfClubFinder {
	constructor(el) {
		this.el = el;
		this.result = {};
		this.fullResult = {};

		this.registerHandleClickSubmit = e => this.onClickSubmit(e);
		this.registerHandleLoadMore = e => this.onLoadMore(e);

		this.init();
	}

	/**
	 * bind click handler to 'loadmore' button
	 **/
	bindLoadMore() {
		const $loadmoreButton = $(selectors.loadmoreButton);
		$loadmoreButton.off('click', this.registerHandleLoadMore);
		$loadmoreButton.on('click', this.registerHandleLoadMore);
	}

	/**
	 * Load all the results and show them on the page
	 * @param {any} ev
	 */
	onLoadMore(ev) {
		ev.preventDefault();

		// render the complete list on the page
		const result = {
			golfClubs: this.fullResult.golfClubs.slice(initialSize, this.fullResult.length),
			showMoreButton: false
		};
		this.showResults(result, $(selectors.resultDiv).find('.c-content'), true);
	}

	showError(data, resultContainer) {
		resultContainer.html('Er is een fout opgetreden, probeer het later nogmaals.');
		Velocity($(selectors.resultDiv), 'slideDown');
	}

	/**
	 * render the template and add
	 * @param {any} data
	 * @param {any} resultContainer
	 */
	showResults(data, resultContainer, append) {
		const template = $(selectors.golfClubFinderListTemplate).html(),
			renderedHtml = mustache.render(template, data);

		if (append) {
			$('.c-coursefinder__loadmore').addClass('hidden');
			resultContainer.append($(renderedHtml)[0]);
		} else {
			resultContainer.html($(renderedHtml)[0]);
			Velocity($(selectors.resultDiv), 'slideDown');
		}

		$(selectors.golftooltip).each(function() {
			var el = this,
				instance = new Tooltip(el, {
					html: true,
					title: `<a href="tel:${el.getAttribute('data-tt-title')}">${el.getAttribute('data-tt-title')}</a>`,
					trigger: 'hover'
				});
		});

		$(selectors.sitecoregoals).each(function() {
			SitecoreGoals.addGoalTrigger(this);
		});

		this.bindLoadMore();
	}

	/**
	 * Load Course data and render template with data
	 */
	showGolfClubs() {
		const $resultsElement = $(selectors.resultDiv),
			$resultsContent = $resultsElement.find('.c-content'),
			addressFilter = $(this.el)
				.find(selectors.addressSearchField)
				.val(),
			clubsOrCourses = $(this.el).find(selectors.clubsOrCoursesField).val(),
			fullUrl = url + '?clubscourses=' + clubsOrCourses + '&address=' + addressFilter;

		$resultsContent.empty();

		xhr = null;
		while (xhrList.length > 0) {
			// cancel request if pending
			xhrList[0].abort();
			// remove request from list
			xhrList.splice(xhrList[0], 1);
		}

		xhr = $.ajax({
			type: 'GET',
			url: fullUrl,
			data: xhr
		});

		xhrList.push(xhr);

		xhr.done(result => {
			this.fullResult = result;
			this.result =
				result.golfClubs.length <= initialSize
					? result
					: { golfClubs: result.golfClubs.slice(0, initialSize), showMoreButton: true };
			this.showResults(this.result, $resultsContent, false);
		});

		xhr.fail((jqXHR, textStatus) => {
			this.showError(textStatus, $resultsContent);
		});
	}

	/**
	 * handle Submit button click action
	 * @param {any} event
	 */
	onClickSubmit(event) {
		event.preventDefault();
		this.showGolfClubs();
	}

	/**
	 * Initialize the module
	 **/
	init() {
		$(this.el)
			.find(selectors.submitButton)
			.on('click', this.registerHandleClickSubmit);
	}
}

export { GolfClubFinder };
